import {
  type LyrraOnePublicRegion,
  LYRRAONE_PUBLIC_REGIONS,
  countryToLyrraOneRegion as countryToRegion,
  detectRegionFromTimezone as detectFromTimezone,
  isLyrraOnePublicRegion,
  normalizeLyrraOneRegionParam,
} from '@/lib/lyrraone-market-config';

export type { LyrraOnePublicRegion };
export { LYRRAONE_PUBLIC_REGIONS, isLyrraOnePublicRegion, normalizeLyrraOneRegionParam };

export const LYRRAONE_REGION_STORAGE_KEY = 'lyrraone_public_region';
export const LYRRAONE_REGION_UPDATED_EVENT = 'lyrraone-region-updated';

export function parseSearchParams(search: string): URLSearchParams {
  return new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
}

export function readRegionFromSearch(search: string): LyrraOnePublicRegion | null {
  const params = parseSearchParams(search);
  return normalizeLyrraOneRegionParam(params.get('region'));
}

export function readPreviewRegionFromSearch(search: string): LyrraOnePublicRegion | null {
  const params = parseSearchParams(search);
  return normalizeLyrraOneRegionParam(params.get('preview_region'));
}

export function hasRegionOverrideInSearch(search: string): boolean {
  return readRegionFromSearch(search) !== null || readPreviewRegionFromSearch(search) !== null;
}

export function getActiveRegionFromSearch(search: string): LyrraOnePublicRegion | null {
  return readPreviewRegionFromSearch(search) ?? readRegionFromSearch(search);
}

export function countryToLyrraOneRegion(country: string | null | undefined): LyrraOnePublicRegion | null {
  return countryToRegion(country);
}

export function detectRegionFromTimezone(): LyrraOnePublicRegion {
  return detectFromTimezone();
}

export function readStoredLyrraOneRegion(): LyrraOnePublicRegion | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(LYRRAONE_REGION_STORAGE_KEY);
    if (raw && isLyrraOnePublicRegion(raw)) return raw;
  } catch {
    /* ignore */
  }
  return null;
}

export function storeLyrraOneRegion(region: LyrraOnePublicRegion): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(LYRRAONE_REGION_STORAGE_KEY, region);
    window.dispatchEvent(new CustomEvent(LYRRAONE_REGION_UPDATED_EVENT, { detail: { region } }));
  } catch {
    /* ignore */
  }
}
